
			<div role="main" class="main">

				<section class="page-header">
					<div class="container">
						<div class="row">
							<div class="col-md-12">
								<ul class="breadcrumb">
									<li><a href="#">Anasayfa</a></li>
									<li class="active">Hakkımızda</li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<h1>Hakkımızda</h1>
							</div>
						</div>
					</div>
				</section>

				<div class="container">
					<div class="row">
						<div class="col-md-12 center">
							<h2 class="word-rotator-title mb-lg">
								Intes Technology'nin
								<strong class="inverted inverted-primary">
									<span class="word-rotate" data-plugin-options='{"delay": 2000, "animDelay": 300}'>
										<span class="word-rotate-items">
											<span>vizyonu</span>
											<span>misyonu</span>
											<span>değerleri</span>
										</span>
									</span>
								</strong>
							</h2>

							<p class="lead">
								"En yeni bilişim teknolojilerini kullanarak müşterilerine dünya standartlarında çözümler sunmak" ilkesiyle yola çıkan Intes Technology, Türkiye'nin profesyonel yazılım çözümlerini sunan firmaları arasında yer almaktadır.
							</p>

							<hr class="tall">
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-picture-o "></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">Üstün Yazılım Kalitesi</h4>
									<p class="tall">Müşterilerimizin ihtiyaçlarına yönelik geliştireceğimiz yazılım çözümleri ile öncelikli amacımız, müşterilerimizin kurumsal yapılarının güçlendirilmesi, operasyonel işlerin dijital dünyaya taşınması ve bunların sonucunda kaynak ve maliyet tasarrufu sağlamaktır.</p>
								</div>
							</div>
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-file"></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">Güvenilir</h4>
									<p class="tall">Gelişen ve sürekli değişen dünyanın gerisinde kalmamak adına sistemlerimizi yeni ve güncel tutuyor, size en son teknolojiyi kullanma imkanı sunuyor ve teknoloji danışmanlığı yapıyoruz.</p>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-film"></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">Tasarım Hizmetleri</h4>
									<p class="tall">Intes Technology olarak sizlere kullanıcı dostu arayüze sahip ve kolay kullanılabilen uygulamalar tasarlıyoruz. Uygulamalarınız, zarif bir tasarım (UI), hızlı ve güvenilir bir kullanıcı deneyimi (UX) ile müşterilerinizin karşısına çıkmaktadır.</p>
									<br>
								</div>
							</div>
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-check"></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">İş Sürekliliği</h4>
									<p class="tall">Ürün tesliminden sonra da sizi yalnız bırakmıyor, ürünümüz hayata geçtikten sonra bile takip ve bakımını aksatmıyoruz. Size bir telefon uzaktayız.</p>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-thumbs-o-up"></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">Müşteri Memnuniyeti</h4>
									<p class="tall">Yüksek teknolojiye dayalı, uluslararası standartlarda üretim yapar ve hizmet veririz, müşteri memnuniyetini her şeyin üzerinde tutarız.</p>
									<br><br><br><br>
								</div>
							</div>
							<div class="feature-box feature-box-style-2">
								<div class="feature-box-icon">
									<i class="fa fa-group"></i>
								</div>
								<div class="feature-box-info">
									<h4 class="mb-none">İnovasyon</h4>
									<p class="tall">Gelişen ve sürekli değişen dünyanın gerisinde kalmamak adına kendimizi her gün yenilemeye önem veriyoruz.</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!--<section class="section section-primary mb-none">
					<div class="container">
						<div class="row">
							<div class="counters counters-text-light">
								<div class="col-md-3 col-sm-6">
									<div class="counter">
										<strong data-to="71" data-append="M+">0</strong>
										<label>Mutlu Kullanıcı</label>
									</div>
								</div>
								<div class="col-md-3 col-sm-6">
									<div class="counter">
										<strong data-to="5200">0</strong>
										<label>Kazanç Miktarı</label>
									</div>
								</div>
								<div class="col-md-3 col-sm-6">
									<div class="counter">
										<strong data-to="38.8" data-append="M+">0</strong>
										<label>Gözlük Satışı</label>
									</div>
								</div>
								<div class="col-md-3 col-sm-6">
									<div class="counter">
										<strong data-to="13000">0</strong>
										<label>Büyüme Yüzdesi</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>-->

				<br>
				<br>
				<div class="home-intro" id="home-intro">
					<div class="container">
					</div>
				</div>


				<div class="container">
					<div class="row mt-xlg">
						<div class="col-md-5">
							<h2><strong>Biz</strong> Kimiz</h2>
							<div style="font-size: 16px;  ">
								<p>2015 yılında kuruluşunu gerçekleştirdiğimiz firmamız, iş hayatında uzun yıllar tecrübe edinmiş deneyimli bir kadroya sahiptir. Kuruluşumuzun temelinde, aşkla bağlı olduğumuz, yazılım ve gömülü sistemlerin, ülkemizde de arge çalışmalarının ve geliştirmesinin yürütüldüğü bir oluşum planı yatmaktadır. Yazılım sektöründe web ve mobil yazılımları üzerine yoğunlaşmakla birlikte, mobil platformlarda en güçlü 2 platform olan Android ve IOS platformlarına yazılım geliştirme, eğitim ve danışmanlık hizmeti vermekteyiz. Web yazılımlarında ise C#, Java ve Php dilleri tercih ettiğimiz dillerin başında gelmektedir. Yazılım alanında bir ürünün temsilciliğini yapmamamız ve bağımlılığımızın olmaması, iş ortaklarımıza, onlar için en uygun platformu sunma ve en uygun ürünü oluşturma olanağı sağlamaktadır. Bu bağlamda iş ortaklarımıza, platform, yöntem, eğitim tercihi danışmanlıkları da yapmaktayız.</p>
							</div>
						</div>
						<div class="col-md-7">
							<div class="progress-bars">
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Swift</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Android</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Objective-C</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="300">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>.Net Core</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="600">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>ASP.Net</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="600">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>JAVA</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="600">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Danışmanlık</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="600">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Eğitim</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="600">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
								<div class="progress-label" style="font-size: 16px;  ">
									<span>Tasarım (UI/UX)</span>
								</div>
								<div class="progress">
									<div class="progress-bar progress-bar-primary" data-appear-progress-animation="100%" data-appear-animation-delay="900">
										<span class="progress-bar-tooltip">100%</span>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<section class="call-to-action call-to-action-default with-button-arrow call-to-action-in-footer">
					<div class="container">
						<div class="row">
							<div class="col-md-12">

							</div>
						</div>
					</div>
				</section>

			</div>
